export const OrdenesComprasReporteLang = {
    // ENCABEZADO
    TituloReporte: {
        es: 'Orden de Compras',
        en: 'Purchase Order',
    },
    direccionE: {
        es: 'Dirección de Envío: ',
        en: 'Address Ship To: ',
    },
    direccion: {
        es: 'Dirección: ',
        en: 'Address: ',
    },


    // TABLAS
    proveedor: {
        es: 'Proveedor: ',
        en: 'Supplier: ',
    },
    envioA: {
        es: 'Envío a ',
        en: 'Ship To: ',
    },
    nombre: {
        es: 'Nombre: ',
        en: 'Name: ',
    },
    telefono: {
        es: 'Telefono: ',
        en: 'Phone: ',
    },
    toShip: {
        es: 'Dirección de envío: ',
        en: 'Address Ship To: ',
    },

// TABLA PRINCIPAL
    cantidad: {
        es: 'Cant.',
        en: 'Qty.',
    },
    codigo: {
        es: 'Código',
        en: 'Code',
    },
    producto: {
        es: 'Producto',
        en: 'Product',
    },
    unidad: {
        es: 'Unidad',
        en: 'Units',
    },
    precio: {
        es: 'Precio',
        en: 'Price',
    },
    isv: {
        es: 'ISV',
        en: 'TAX',
    },
    descuento: {
        es: 'Desc.',
        en: 'Disc.',
    },
    descripcion: {
        es: 'DESCRIPCION.',
        en: 'DESCRIPTION.',
    },


    desc: {
        es: 'Descuento',
        en: 'Discount',
    },
    fletes: {
        es: 'Fletes',
        en: 'Freigths',
    },
    otros: {
        es: 'Otros',
        en: 'Others',
    },

    terminosPago: {
        es: 'Términos de Pago: ',
        en: 'Payment Terms: ',
    },
    terminosInco: {
        es: 'Términos Inco: ',
        en: 'InconTerms: ',
    },
    comentario: {
        es: 'Comentario: ',
        en: 'Comment: ',
    },

    // FIRMAS
    deptoCompras: {
        es: 'Departamento de Compras',
        en: 'Purchase Departament',
    },



    // FOOTER
    fecha: {
        es: 'Fecha: ',
        en: 'Date: ',
    },
    request: {
        es: 'Requisa: ',
        en: 'Request: ',
    },
    original: {
        es: 'Original: Proveedor / Operaciones (Solicitud de Compra)',
        en: 'Original: Supplier / Operations (Purchase Request) ',
    },
    copia: {
        es: 'Copia 1: Contabilidad',
        en: 'Copy 1: Accounting ',
    },
    copia2: {
        es: 'Copia 2: Desarrollo de Telas / Bodega',
        en: 'Copy 2: Fabric Development / Warehouse ',
    },
    textFinal: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: Pride Performance Fabrics S.Ade C.V. El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: Pride Performance Fabrics S.Ade C.V. Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },
    textFinal2: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: Pride Performance Fabrics S.Ade C.V. El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: Pride Performance Fabrics S.Ade C.V. Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },
    textFinal3: {
        es: 'Esta orden de compra no será válida sin la firma y sello autorizado de: Pride Performance Fabrics S.Ade C.V. El pago no se realizará en función de los artículos aceptados por nuestro departamento de control de calidad. El número de orden de compra debe reflejarse en todas las facturas y listas de empaque.',
        en: 'This purchase order will not be valid without authorized sign and seal from: Pride Performance Fabrics S.Ade C.V. Payment will not be done based on accepted items by our quality control department. Purchase Order number must be reflected in all invoices and packing lists.',
    },


    //Reporte Requisa
    //Tabla encabezado
    PR:{
        es:"Requisición de Compra",
        en:"Purchase Requisition"
    },
    prioridad:{
        es:"Prioridad",
        en:"Priority"
    },
    fecha1:{
        es:"Fecha Creación",
        en:"Creation Date"
    },
    tipo:{
        es:"Tipo",
        en:"Type"
    },
    proSG:{
        es:"Proveedor Sug",
        en:"Sug Provider"
    },
    area:{
        es:"Area",
        en:"Area"
    }, 
    creadoNombre:{
        es:"Creado por",
        en:"Created by"
    },
    solicita:{
        es:"Solicita",
        en:"Request"
    },

    //tabla firmas
    autorizaciones:{
        es:"Autorizaciones",
        en:"Authorizations"
    },
    coordinador:{
        es:"Coordinador",
        en:"Coordinator"
    },
    gteDepto:{
        es:"Gte. Departamento",
        en:"Dept. Manager"
    },
    areaDirector:{
        es:"Director de Area",
        en:"Area Director"
    },
    finanzas:{
        es:"Finanzas",
        en:"Finance"
    },
    gtePlanta:{
        es:"Gte. Planta",
        en:"Plant Manager"
    },

    //Tabala detalles Requisa
    moneda:{
        es:"M",
        en:"C"
    },
    unidaPR:{
        es:"Unid",
        en:"Unit"
    },
    comentarioPR: {
        es: 'Comentario',
        en: 'Comment',
    },
    fechaImpresion: {
        es: 'Fecha Impresión:',
        en: 'Print Date:',
    },
}